<div class="wallet-page">
  <section class="header">
    <div class="sp-container">
      <div class="sp-row">
        <div class="sp-col sp-col--6 sp-col-sm--12">
          <div class="header-details">
            <div class="header-title">
              <h3>رصيد سبيرو</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="user-wallet-edit" *ngIf="wallet">
    <div class="sp-container">
      <div class="sp-row">
        <div class="sp-col sp-col--8 sp-col-sm--12">
          <sp-card spTitle="رصيد سبيرو">
            <p class="center">{{ wallet.amount | number: '1.1-2' }} ريال</p>
          </sp-card>
        </div>
        <div class="sp-col sp-col--4 sp-col-sm--12">
          <sp-card spTitle="قابل للإسترجاع">
            <p class="center">{{ wallet.refundableAmount | number: '1.1-2' }} ريال</p>
          </sp-card>
        </div>
      </div>
      <div class="sp-row" *ngIf="wallet.walletTransactions.length">
        <div class="sp-col sp-col--10 sp-col-sm--12">
          <h3 class="heading-3">تفاصيل العمليات</h3>
        </div>
        <!-- <div class="sp-col sp-col--2 sp-col-sm--12 pull--end">
          <sp-button [label]="'طلب إسترجاع'" [size]="'secondary'" (clickAction)="refundRequest()"></sp-button>
        </div> -->
        <div class="sp-col sp-col--12">
          <div class="content">
            <div class="table-content">
              <sp-table [style]="'--zeebra'">
                <sp-table-head>
                  <sp-table-head-cell width="16"></sp-table-head-cell>
                  <sp-table-head-cell>الوصف</sp-table-head-cell>
                  <sp-table-head-cell>المبلغ</sp-table-head-cell>
                  <sp-table-head-cell></sp-table-head-cell>
                </sp-table-head>
                <sp-table-body>
                  <ng-template ngFor let-wa [ngForOf]="wallet.walletTransactions" let-j="index">
                    <sp-table-body-row [class.--odd]="j % 2">
                      <sp-table-body-cell>
                        <span
                          class="wallet-transaction"
                          [class.debit]="wa.transactionType === 'debit'"
                          [class.credit]="wa.transactionType === 'credit'"
                        ></span>
                      </sp-table-body-cell>
                      <sp-table-body-cell>
                        <div class="title">{{ wa.title }}</div>
                        <div class="description">
                          {{ wa.transactionFor && wa.transactionFor === 'delivery-fees' ? 
                          'رسوم التوصيل - ' +  wa.directOrderId.customId
                           : (wa.description || 'لا يوجد وصف')}}</div>
                      </sp-table-body-cell>
                      <sp-table-body-cell>
                        <div class="date">{{ wa.createdAt | date: 'hh:mma dd/MM/yyyy' }}</div>
                        <span
                          class="wallet-transaction-type"
                          [class.debit]="wa.transactionType === 'debit'"
                          [class.credit]="wa.transactionType === 'credit'"
                          >{{ wa.amount | number: '1.1-2' }} ريال</span
                        >
                      </sp-table-body-cell>
                      <sp-table-body-cell>
                        <sp-button
                          [style]="'ghost'"
                          [disabled]="wa.isRefunding"
                          [label]="'إسترجاع'"
                          (clickAction)="refundWalletTransaction(wa)"
                          *ngIf="wa.isRefundable && !wa.isPaidOut && wa.transactionClass === 'refund'"
                        ></sp-button>
                      </sp-table-body-cell>
                    </sp-table-body-row>
                  </ng-template>
                </sp-table-body>
              </sp-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
